import Profile from "../components/profile/index";
import Layout from "../components/layouts/allpagelayout";
export default function ProfilePage() {
  return (
    <Layout>
      <Profile />
    </Layout>
  );
}